import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { IForgotPassword_Request, IForgotPassword_Response, ILogin_Response, ILogin_Request, IRegister_Request, IRegister_Response, ICurrentUserEntity, ICurrentUser, IVerifyAdminLogin_Request, IUpdatePersonalInfo_Request, IUpdatePersonalInfo_Response } from './account.model';
import { ApiService } from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private readonly endpoint = "auth";
  public currentUserSource = new BehaviorSubject<ICurrentUser | null>(this.getUserFromStorage());
  public currentUser$ = this.currentUserSource.asObservable();

  constructor(private apiService: ApiService) { }

  registerUser(model: IRegister_Request) {
    return this.apiService.post<IRegister_Request, IRegister_Response>({
      Url: `${this.endpoint}/register`,
      Body: model
    });
  }

  login(model: ILogin_Request) {
    return this.apiService.post<ILogin_Request, ILogin_Response>({
      Url: `${this.endpoint}/login`,
      Body: model
    })
      .pipe(
        map((response) => {
          if (response && response.data && response.auth.token) {
            const userLogin: ICurrentUser = {
              firstName: response.data?.firstName,
              email: response.data?.email,
              username: response.data?.username,
              token: response.auth.token,
              role: response.data?.role,
              registrationStep: response.data?.registrationStep,
              registrationCompleted: response.data?.registrationCompleted
            };
            localStorage.setItem("user", JSON.stringify(userLogin));
            this.currentUserSource.next(userLogin);
          }
          return response;
        }));
  }

  verifyAdminLogin(model: IVerifyAdminLogin_Request) {
    return this.apiService.post<IVerifyAdminLogin_Request, ILogin_Response>({
      Url: `${this.endpoint}/admin-login-verify`,
      Body: model
    })
      .pipe(
        map((response) => {
          if (response && response.data && response.auth?.token) {
            const userLogin: ICurrentUser = {
              firstName: response.data?.firstName,
              email: response.data?.email,
              username: response.data?.username,
              token: response.auth.token,
              role: response.data?.role,
              registrationStep: response.data?.registrationStep,
              registrationCompleted: response.data?.registrationCompleted
            };
            localStorage.setItem("user", JSON.stringify(userLogin));
            this.currentUserSource.next(userLogin);
          }
          return response;
        }));
  }

  resendAdminLoginCode(accountId: string) {
    return this.apiService.post<any, any>({
      Url: `${this.endpoint}/resend-admin-login-otp`,
      Body: { accountId: accountId, code: "" }
    });
  }

  resendEmailVerification(email: string) {
    return this.apiService.post<any, any>({
      Url: `${this.endpoint}/resend-email-verification`,
      Body: { email: email }
    });
  }

  verifyEmail(accountId: string, email: string, token: string) {
    return this.apiService.post<any, any>({
      Url: `${this.endpoint}/email-verification`,
      Body: { accountId: accountId, email: email, token: token }
    });
  }

  sendPhoneVerification(phone: string) {
    return this.apiService.post<any, any>({
      Url: `verification/send-phone-otp`,
      Body: { phone: phone }
    });
  }

  verifyPhone(phone: string, code: string) {
    return this.apiService.post<any, any>({
      Url: `verification/phone-verification`,
      Body: { phone: phone, code: code }
    });
  }

  forgot(model: IForgotPassword_Request) {
    return this.apiService.post<IForgotPassword_Request, IForgotPassword_Response>({
      Url: `${this.endpoint}/forgot-password`,
      Body: model
    });
  }

  GetAllUser(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<ICurrentUserEntity>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  UpdateUser(body: ICurrentUserEntity) {
    return this.apiService.put<ICurrentUserEntity, object>({
      Url: `${this.endpoint}/update-user`,
      Body: body
    });
  }

  updatePersonalInfo(model: IUpdatePersonalInfo_Request) {
    return this.apiService.post<IUpdatePersonalInfo_Request, IUpdatePersonalInfo_Response>({
      Url: `${this.endpoint}/update-personal-info`,
      Body: model
    });
  }

  getMapsAutocomplete(input: string) {
    const params = new HttpParams().set('input', input);
    return this.apiService.get<any>({
      Url: `thirdparty/maps/autocomplete`,
      Params: params
    });
  }

  getMapsPlaceDetails(placeId: string) {
    const params = new HttpParams().set('placeId', placeId);
    return this.apiService.get<any>({
      Url: `thirdparty/maps/details`,
      Params: params
    });
  }

  getMapsGeocode(lat: number, lng: number) {
    const params = new HttpParams().set('lat', lat.toString()).set('lng', lng.toString());
    return this.apiService.get<any>({
      Url: `thirdparty/maps/geocode`,
      Params: params
    });
  }

  setCurrentUser(user: ICurrentUser) {
    this.currentUserSource.next(user);
  }

  logout() {
    localStorage.removeItem("user");
    this.currentUserSource.next(null);
  }

  private getUserFromStorage(): ICurrentUser | null {
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        return JSON.parse(userString);
      }
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      localStorage.removeItem("user");
    }
    return null;
  }

  private CheckRole() {
    // if (role == "admin" || role == "user")
    // {
    //   throw "Failed to get role contact support";
    // }
  }
}